import React from 'react';

function RechnungErstellen() {
    return (
        <h1>RechnungErstellen</h1>
    );
}

export default RechnungErstellen;